import { getListOfCadenceByLeadId } from "../types/cadence-lead.types";
const initState = {
  data: [],
  count: 0,
  isLoading: false,
  error: false,
};

export default function LeadLinkedCadenceReducer(state = initState, action = {}) {
  switch (action.type) {
    case getListOfCadenceByLeadId.GET_LIST_OF_CADENCE_BY_LEAD_ID_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case getListOfCadenceByLeadId.GET_LIST_OF_CADENCE_BY_LEAD_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        count: action.payload.count,
      };
    case getListOfCadenceByLeadId.GET_LIST_OF_CADENCE_BY_LEAD_ID_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}
